
<div
  class="rfp-rr-title-section-174-or rr-title-section"
  :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
>
  <p
    class="rfp-rr-title-section-175-or float-left"
    :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
  >
    {{ sectionTitle }}
  </p>
  <div
    v-if="writeReviewEnable"
    role="button"
    tabindex="0"
    class="rfp-rr-title-section-176-or write-review-btn float-right"
    :class="{ 'rfp-rr-rating-rtl-float-left': isRightToLeftActive }"
    @click="writeReviewStatus"
  >
    {{ reviewPopupButton }}
  </div>
</div>
